import styles from 'css/src/components/public-pages/sections/ProfessionalVideosSection.module.scss';

import React, { useCallback, useRef, useState } from 'react';

import IconCircle from 'js/src/components/common/ui/IconCircle';

const ProfessionalVideosSection = React.memo(function ProfessionalVideosSection() {
    const videoRef = useRef<HTMLVideoElement>(null);
    const [hasStarted, setHasStarted] = useState(false);

    const startPlayback = useCallback(() => {
        const video = videoRef.current;
        if (!video) {
            return;
        }
        setHasStarted(true);
        void video.play();
    }, []);

    return (
        <div className="p-l5-16 p-l5-sm-48 section-2 section-dark-grey pb-l5-48">
            <div className="container">
                <div className="justify-content-center align-items-center">
                    <div className="d-flex flex-column align-items-start my-l5-48">
                        <h2 className={styles['professional-videos-heading']}>
                            Professional videos without the drama
                        </h2>
                        <p
                            className={`font-l5 font-l5--regular my-l5-16 px-l5-0 ${styles['professional-videos-copy']}`}
                        >
                            No scriptwriting background? No problem. Lumen5 makes video creation
                            feel as easy as building a slide. No scripts, no learning curve, just
                            drag, drop, and done.
                        </p>
                    </div>
                    <div
                        className={`border-video-container mb-l5-64 ${styles['professional-videos-player']}`}
                    >
                        <video
                            ref={videoRef}
                            className="w-100"
                            playsInline
                            disablePictureInPicture
                            disableRemotePlayback
                            controls={hasStarted}
                            onPlay={() => setHasStarted(true)}
                            aria-label="Explainer video - How Lumen5 helps your team create on-brand videos at scale."
                            poster="https://cdn.lumen5.com/lumen5-site-images/2025-website-assets/videos/landing_explainer/v2/Explainer-960.webp"
                            preload="none"
                        >
                            <source
                                src="https://cdn.lumen5.com/lumen5-site-images/2025-website-assets/videos/landing_explainer/v2/Explainer.mp4"
                                type="video/mp4"
                            />
                            <source
                                src="https://cdn.lumen5.com/lumen5-site-images/2025-website-assets/videos/landing_explainer/v2/Explainer.webm"
                                type="video/webm"
                            />
                        </video>
                        {!hasStarted && (
                            <button
                                type="button"
                                className={styles['professional-videos-play']}
                                onClick={startPlayback}
                                aria-label="Play the Lumen5 explainer video"
                            >
                                <span className={styles['professional-videos-play-ring']}>
                                    <IconCircle
                                        materialIconName="play_arrow"
                                        color="color-black"
                                        backgroundColor="white"
                                        className={`${styles['professional-videos-play-icon']} material-symbols-f1`}
                                    />
                                </span>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
});

export default ProfessionalVideosSection;
